/**
 * Composable for working with AidboxQuery responses
 */

/**
 * Extracts data array from AidboxQuery response
 * Handles different response formats from Aidbox API
 *
 * @param {Object} result - The response object from $httpFhirApi
 * @returns {Array} - Array of data rows, filtered to remove null/undefined entries
 */
export function extractAidboxQueryData(result) {
    let data = [];

    if (Array.isArray(result?.originalData?.entry)) {
        data = result.originalData.entry;
    }
    // Fallback: check originalData.data (in case interceptor behavior changes)
    else if (Array.isArray(result?.originalData?.data)) {
        data = result.originalData.data;
    }

    // Filter out any undefined/null entries
    return data.filter((row) => row != null && typeof row === 'object');
}

/**
 * Builds a query string from params object, filtering out undefined/null values
 *
 * @param {Object} params - Object with query parameters
 * @returns {string} - URL-encoded query string
 */
export function buildAidboxQueryString(params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            searchParams.append(key, String(value));
        }
    });
    return searchParams.toString();
}

export default {
    extractAidboxQueryData,
    buildAidboxQueryString,
};
